<template>
    <div class="record-box">
        <fixed-header :left="true" title="领取记录" />
        <ul v-if="list.length > 0">
            <li v-for="item in list" @click="toDetails(item.orderId)" :key="item.orderId">
                <div class="prod-img"><img :src="item.goodsImageUrl" alt=""></div>
                <div class="prod-info">
                    <div class="prod-name">{{item.goodsName}}</div>
                    <div class="prod-get-time">
                        <span class="time">领取时间：{{item.createTimestamp}}</span>
                        <span class="btn">查看详情</span>
                    </div>
                </div>
            </li>
        </ul>
        <div class="no-data" v-if="loaded && list.length === 0">
            <img src="../../assets/imgs/no-data.png" alt="">
            <div class="font">暂无领取记录</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import FixedHeader from '../../components/FixedHeader';
    import {queryCrmOrderReceiveRecord} from '../../api';
    import {callAppHandler} from '../../utils';

    export default {
        name: 'RecordList',
        components: {FixedHeader},
        computed: {
            ...mapState(['userInfo', 'isApp'])
        },
        data() {
            return {
                loaded: false,
                list: []
            }
        },
        mounted() {
            if (this.isApp) {
                callAppHandler({
                    type: 'statusBar',
                    params: {
                        theme: '1'
                    }
                });
            }
            this.getData()
        },
        methods: {
            toDetails(id) {
                this.$router.push({name: 'recordDetail', query: {id}})
            },
            // 获取数据
            getData() {
                queryCrmOrderReceiveRecord({
                    midMemberId: this.userInfo.memberId
                }).then(res => {
                    if (res.code === 200) {
                        this.list = res.data
                        this.loaded = true
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    @import "../../assets/style/variable";

    .record-box {
        background-color: #f3f3f3;

        .no-data {
            margin-top: 300/@baseSize;

            img {
                display: block;
                margin: 0 auto;
                width: 406/@baseSize;
                height: auto;
            }

            .font {
                font-size: 26/@baseSize;
                margin-top: 32/@baseSize;
                color: #999999;
                text-align: center;
            }
        }

        ul {
            margin: 20/@baseSize 30/@baseSize 0 30/@baseSize;

            li {
                margin-bottom: 20/@baseSize;
                background-color: #ffffff;
                padding: 20/@baseSize;
                border-radius: 10/@baseSize;
                display: flex;

                .prod-img {
                    margin-right: 20/@baseSize;

                    img {
                        width: 140/@baseSize;
                        height: 140/@baseSize;
                        background-color: #f3f3f3;
                        display: block;
                    }
                }

                .prod-info {
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    justify-content: space-between;

                    .prod-name {
                        font-size: 26/@baseSize;
                        margin-right: 170/@baseSize;
                    }

                    .prod-get-time {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;

                        .time {
                            font-size: 22/@baseSize;
                            color: #999999;
                            line-height: 50/@baseSize;
                        }

                        .btn {
                            width: 140/@baseSize;
                            height: 50/@baseSize;
                            line-height: 50/@baseSize;
                            text-align: center;
                            color: #ffffff;
                            font-size: 22/@baseSize;
                            border-radius: 50/@baseSize;
                            background-color: #317CED;
                        }
                    }
                }
            }
        }
    }
</style>
